<template>
  <v-menu offset-y left transition="slide-y-transition" min-width="248">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        class="theme-btn"
        :aria-label="`Tema: ${currentMeta.label}`"
        :title="`Tema: ${currentMeta.label}`"
      >
        <v-icon size="21">{{ currentMeta.icon }}</v-icon>
      </v-btn>
    </template>

    <v-list dense class="theme-list">
      <v-subheader class="theme-subheader">Modo de cor</v-subheader>
      <v-list-item
        v-for="t in themes"
        :key="t.value"
        @click="choose(t.value)"
        :class="{ 'theme-item--active': t.value === current }"
      >
        <v-list-item-icon class="mr-3 my-2">
          <span class="theme-swatch" :style="{ background: t.swatch }"></span>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="theme-item-title">
            {{ t.label }}
          </v-list-item-title>
          <v-list-item-subtitle class="theme-item-desc">
            {{ t.description }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action v-if="t.value === current" class="my-0">
          <v-icon size="18" color="primary">mdi-check</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  THEMES,
  themeState,
  setTheme,
  getThemeMeta,
} from "@/services/themeService";

/**
 * Seletor de modo de cor da navbar.
 * Fica fora da área autenticada de propósito: o tema é uma preferência do
 * navegador (localStorage), então funciona também para quem não fez login.
 */
export default {
  name: "ThemeSelect",

  data: () => ({ themes: THEMES }),

  computed: {
    current() {
      return themeState.current;
    },
    currentMeta() {
      return getThemeMeta(themeState.current);
    },
  },

  methods: {
    choose(value) {
      if (value === this.current) return;
      // Passa o Vuetify para sincronizar o tema dele (color="primary", dark).
      setTheme(value, this.$vuetify);
    },
  },
};
</script>

<style scoped>
.theme-btn {
  color: var(--ds-text-600) !important;
}
.theme-btn:hover {
  color: var(--ds-primary) !important;
}

.theme-list {
  background: var(--ds-surface-white) !important;
}

.theme-subheader {
  height: 32px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--ds-text-muted);
}

.theme-swatch {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.35);
}

.theme-item-title {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--ds-text-strong);
}
.theme-item-desc {
  font-size: 11.5px;
  color: var(--ds-text-muted);
}

.theme-item--active {
  background: var(--ds-blue-50);
}
</style>
